import { PageContainer } from '@components/PageContainer';
import { PermissionGate } from '@components/PermissionGate';
import { TemplatesList } from '@components/TemplatesList';
import { Button, DropdownPositions, Pagination, PlusIcon } from '@gurupay/gp-ui-library';
import { usePagination } from '@hooks/usePagination';
import { useTemplates } from '@hooks/useTemplates';
import { useTranslation } from 'react-i18next';
import { Capability } from 'types/roles';

export const TemplatesListPage = () => {
	const { t } = useTranslation('', { keyPrefix: 'templatesList' });
	const {
		currentPage,
		setCurrentPage,
		pageSize,
		pageOptions,
		handlePageSizeChange,
		pageText,
		totalCountText,
	} = usePagination();
	const pagination = {
		page: currentPage,
		per_page: pageSize,
	};
	const { data: templateCache } = useTemplates(pagination);
	const totalCount = templateCache?.pagination?.count;

	return (
		<PageContainer backUrl="/payments" title={t('title', { count: totalCount ?? 0 })}>
			<PermissionGate capability={Capability.MANAGE_TEMPLATE}>
				<Button
					href="/templates/new"
					className="flex-row-reverse mb-space-40 inline-flex max-mobile:mt-space-24"
					icon={<PlusIcon />}
					variant="primary-black"
				>
					{t('newTemplate')}
				</Button>
			</PermissionGate>
			<TemplatesList params={pagination} />
			{(totalCount ?? 0) > pageSize && (
				<Pagination
					className="mt-space-32!"
					currentPage={currentPage}
					dropdownOpenPosition={DropdownPositions.TOP}
					onPageChange={setCurrentPage}
					onPageSizeChange={handlePageSizeChange}
					pageOptions={pageOptions}
					pageSize={pageSize}
					pageText={pageText}
					totalCount={totalCount ?? 0}
					totalCountText={totalCountText}
				/>
			)}
		</PageContainer>
	);
};
